import Loadable from 'react-loadable';

import { LoadingPage } from 'src/components/react-loadable';

export const ReviewGroupsLoadable = Loadable<any, never>({
  loading: LoadingPage,
  loader: () => import('./review-groups'),
});
